import React from 'react'
import styles from './MicrositeSerpPreview.module.css'

/**
 * MicrositeSerpPreview
 * Simulated Google search result snippet, showing how the meta
 * title + URL + description will appear in search results. Used
 * on MicrositeSeo to give immediate visual feedback while editing.
 *
 * Usage:
 *   <MicrositeSerpPreview
 *     title={form.metaTitle}
 *     description={form.metaDescription}
 *     url="prodemo.lokacipro.com"
 *   />
 */
const MicrositeSerpPreview = ({ title, description, url = 'yoursalon.lokacipro.com' }) => {
    const displayTitle = title?.trim() || 'Your page title will appear here'
    const displayDesc = description?.trim() || 'Your meta description will appear here. Aim for 150–160 characters to avoid truncation in search results.'

    return (
        <div className={styles.wrap}>
            <div className={styles.label}>Google search preview</div>
            <div className={styles.card}>
                <div className={styles.urlRow}>
                    <div className={styles.favicon} />
                    <span className={styles.url}>{url}</span>
                </div>
                <div className={styles.title}>{displayTitle}</div>
                <div className={styles.description}>{displayDesc}</div>
            </div>
        </div>
    )
}

export default MicrositeSerpPreview